// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__K6zBG","h2Txt":"Hero_h2Txt__icqzK","heroP":"Hero_heroP__BnREj","heroBtn":"Hero_heroBtn__AT+rJ","ctaBtn":"Hero_ctaBtn__abpqR"};